<template>
  <VAutocomplete
    v-model="client"
    :label="$t('forms.labels.client')"
    :items="displayedClients"
    :rules="{ required: true }"
    :loading="loading"
    cacheItems
    returnObject
    @search="debouncedClientSearch"
    @input="updateData"
  />
</template>

<script>
import { debounce } from 'lodash';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VAutocomplete,
    },
    data() {
        return {
            clients: [],
            client: null,
            associatedClients: [],
            loading: false,
            debouncedClientSearch: debounce(this.searchClients, 500),
        };
    },
    computed: {
        displayedClients() {
            return this.clients.map(client => ({
                name: `${client.name} [${client.accountNumber}]`,
                id: client.id,
                disabled: this.isClientAssociated(client.id),
            }));
        },
        associatedClientsById() {
            return this.associatedClients.reduce((associatedClientsById, associatedClient) => ({
                ...associatedClientsById,
                [associatedClient.id]: associatedClient.id,
            }), {});
        },
        isClientAssociated() {
            return clientId => clientId in this.associatedClientsById;
        },
    },
    async created() {
        this.associatedClients = await this.getMemberClients();
        this.clients = await this.getClients();
    },
    methods: {
        async searchClients(search) {
            this.loading = true;
            this.clients = await this.getClients(search);
            this.loading = false;
        },
        getClients(search) {
            return this.$rq.getClients({ search, perpage: 100 })
                .then(response => response.data.clients);
        },
        getMemberClients() {
            return this.$rq.getMemberClients(this.$route.params.memberId, { onlyExplicit: true })
                .then(response => response.data.clients);
        },
        updateData() {
            this.$emit('sendData', this.client);
        },
    },
};
</script>
